export const chartOptions = {
  chart: {
    toolbar: {
      show: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  colors: ["#008FFB"],
  xaxis: {
    type: 'category',
    categories: [""],
    labels: {
      style: {
        colors: [""],
        fontSize: '18px',
      },
    },
  },
  yaxis: {
    reversed: true,
  },
  grid: {
    padding: {
      right: 20,
    },
  },
  tooltip: {
    x: {
      show: false,
      formatter: (val: number): string => `${val}`,
    },
    y: {
      formatter: (val: number): string => `${val} Biz`,
    },
  },
}

export default chartOptions
